import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";
// import "./applicationStatusBar.css";
import Container from "react-bootstrap/Container";
export const ApplicationStatusBar = (props) => {
    const { status, percentage, isIndividualAssessment, indexPlusOne } = props;
    let calculatedPercentage;
    if (!percentage) {
        calculatedPercentage = 23;
    } else {
        calculatedPercentage = percentage;
    }

    return (
        <>
            <Container className="">
                <Col>
                    <Row className="mt-2">
                        {!isIndividualAssessment && (
                            <Row className="text-center">
                                <h2><u>Application #{indexPlusOne}</u></h2>
                            </Row>
                        )}

                        {isIndividualAssessment && (
                            <Row className="text-center">
                                <h2>Application #{indexPlusOne}: Individual Assessment</h2>
                            </Row>
                        )}
                        
                        <Row className="text-center">
                            <h4>
                                    Status: <b>{props.message}</b>

                            </h4>
                        </Row>
                        <Row>
                                <h5 className="status-font text-center">
                                    Application Received: {props.received}
                                </h5>
                        </Row>

                       {/* <Row>
                            <Row className="d-flex justify-content-start">
                                <ProgressBar
                                    className="px-0 mx-4"
                                    striped
                                    variant={status}
                                    animated
                                    now={calculatedPercentage}
                                />
                            </Row>
                            <Row>
                                <h6 className="status-font text-center">
                                    {props.message}
                                </h6>
                            </Row>
                        </Row> */}
                    </Row>
                </Col>
            </Container>
        </>
    );
};
